import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Tooltip } from "@mui/material";
import { faTimes } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ResetConfirmModal = (props) => {
  const {
    open,
    setOpen,
    message,
    confimClick,
    modalHeader,
    cnfrmBtnName,
    cancelBtnName,
    checkStatus
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "right" }}>
          {modalHeader ? modalHeader : ""}
        </DialogTitle>
        <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
          <DialogContentText id="alert-dialog-description">
            {message ? message : ""}
          </DialogContentText>
          {message === "Are you sure to Update Employee Master?" && <Button color="inherit" onClick={handleClose} ><FontAwesomeIcon size="lg" icon={faTimes} /></Button>}
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "0.5rem",
            marginBottom: "1rem",
            // margin: "1rem",
          }}
        >
          <Button variant="contained" onClick={checkStatus == 356 ? () => confimClick() : handleClose} color="inherit">
            {cancelBtnName ? cancelBtnName : "Cancel"}
          </Button>
          <Tooltip title={props.tooltipMsg}>
            <Button
              onClick={() => confimClick(true)}
              variant="contained"
              color="primary"
              autoFocus
            >
              {cnfrmBtnName ? cnfrmBtnName : "Continue"}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ResetConfirmModal;
